const locales = {
    driver_performance_dateRange_startDate: 'Fecha de Inicio',
    driver_performance_dateRange_endDate: 'Fecha de Fin',
};

export default locales;
